module.exports = __webpack_public_path__ + "static/media/WU.51827e81.svg";